import styled from 'styled-components';

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const ModalMain = styled.div`
  width: 500px;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;

  @media screen and (max-width: 480px) {
    width: 100%;
  }
`;

export const Question = styled.p`
  margin: 0;
  text-align: center;
  color: ${(props) => props.theme.colors.textPrimary};
  font-family: Roboto, sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.5;

  @media screen and (max-width: 768px) {
    font-size: 16px;
  }
`;

export const QuestionHighlight = styled.span`
  font-weight: 700;
`;

export const Options = styled.div`
  display: flex;
  justify-content: center;
`;

export const RatingWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
`;

export const SelectedLabel = styled.span`
  text-align: center;
  color: ${(props) => props.theme.colors.textPrimary};
  font-family: Roboto, sans-serif;
  font-size: 13px;
  font-weight: 700;
  line-height: 1.35;
`;

export const Description = styled.p`
  margin: 0;
  text-align: center;
  color: ${(props) => props.theme.colors.textPrimary};
  font-family: Roboto, sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 1.45;
`;

export const SuggestionSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const SuggestionLabel = styled.label`
  color: ${(props) => props.theme.colors.textPrimary};
  font-family: Roboto, sans-serif;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.4;

  @media screen and (max-width: 768px) {
    font-size: 15px;
  }
`;

export const ModalActions = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;

  @media screen and (max-width: 960px) {
    .dark & .ppsa-button.confirmation-modal:hover {
      background: var(--primary-hover);
    }
  }
`;
